/**
 * The Meet mark — canonical bars from Brand Identity System.
 * @see reference_files/claude_html/TheRallyAlly - The Meet Brand System.html
 */
export default function MeetBrandMark({ size = 22, variant = "light", className = "" }) {
  const ink = variant === "dark" ? "#FAFAF8" : "#121212";
  const rally = variant === "dark" ? "#1ED690" : "#14BF7D";

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 96 96"
      fill="none"
      className={className}
      aria-hidden
    >
      <rect
        x="25"
        y="14"
        width="21"
        height="46"
        rx="10.5"
        fill={ink}
        transform="rotate(8 35.5 37)"
      />
      <rect
        x="50"
        y="36"
        width="21"
        height="46"
        rx="10.5"
        fill={rally}
        transform="rotate(-8 60.5 59)"
      />
    </svg>
  );
}
